$(function() {

	// Vars
	var $form = $('form#subject-invites'),
		$addStakeholder = $form.find('#subject-invites-add-stakeholder'),
		$stakeholders = $('#subject-invites-stakeholders'),
		$template = $('#subject-invites-stakeholder-template');

	// Check form
	if (!$form.length) return;

	// Refresh page if user arrived via back button
	if (performance.navigation.type == 2) window.location.reload(true);

	// Add stakeholder
	$addStakeholder.click(function() {
		addStakeholderFromTemplate();
	});

	// Add stakeholder from template
	function addStakeholderFromTemplate() {

		if ($stakeholders.find('.subject-invite').length >= window.serendis.stakeholders.max) {
			alert('A maximum of ' + window.serendis.stakeholders.max + ' stakeholders may be added.');
			return false;
		}

		var $html = $template.find('> div').clone(),
			timestamp = uuidv4();

		$html.find('[data-name="stakeholder_ids"]').val(timestamp);
		$html.find('[data-name="disabled_stakeholder_ids"]').val(timestamp);
		$html.find('[data-name="first_name"]').attr('name', 'first_name_' + timestamp);
		$html.find('[data-name="last_name"]').attr('name', 'last_name_' + timestamp);
		$html.find('[data-name="relationship"]').attr('name', 'relationship_' + timestamp);
		$html.find('[data-name="relationship_id"]').attr('name', 'relationship_id_' + timestamp);
		$html.find('[data-name="relationship_relative_seniority"]').attr('name', 'relationship_relative_seniority_' + timestamp);
		$html.find('[data-name="email"]').attr('name', 'email_' + timestamp);

		$stakeholders.append($html);
		// refreshNumbering();
		var $stakeholder = $stakeholders.find('.subject-invite').last();
		$stakeholder.find('input[type="text"]:first').focus();
		$(window).scrollTop($stakeholder.offset().top);
	}

	// Relationship
	$form.on('change', '[data-name="relationship_id"]', function() {

		var other = $(this).val() == 'other',
			$input = $(this).parents('.form-group').find('[data-name="relationship"]'),
			$relativeSeniority = $(this).parents('.subject-invite-inner').find('.relative-seniority');

		$input.add($relativeSeniority)[!other ? 'addClass' : 'removeClass']('hidden');

		if (other) {
			$input.focus();
		}

	});

	// Type
	$form.find('[name="selfassessment"]').change(function() {
		$('.subject-invites-list')[$(this).val() == '1' ? 'addClass' : 'removeClass']('hidden');
	});

	// Remove stakeholder
	$stakeholders.on('click', '.remove', function() {
		
		if (confirm('Remove this stakeholder?')) {
			$(this).parents('.subject-invite').remove();
			if (!$stakeholders.find('.subject-invite').length) {
				addStakeholderFromTemplate();
			}
			// refreshNumbering();
		}

		return false;
	});

	// Generate UUID
	function uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// Submit
	$form.submit(function() {

		if ($form.valid()) {

			if ($stakeholders.find('.subject-invite').length < window.serendis.stakeholders.min) {
				alert('Please add at least ' + window.serendis.stakeholders.min + ' stakeholders.');
				return false;
			}

		}

	});

});